export default __webpack_public_path__ + "static/media/type_7_2.2ee22750.svg";